const USERS_DATA_REQUEST = 'USERS_DATA_REQUEST';
const USERS_DATA_SUCCESS = 'USERS_DATA_SUCCESS';
const USERS_DATA_FAILURE = 'USERS_DATA_FAILURE';
const USERS_ADDED = 'USERS_ADDED';
const CHANGE_DATA_BY_ROLE = 'CHANGE_DATA_BY_ROLE';

const CHANGE_USER_DATA_BY_ID = 'CHANGE_USER_DATA_BY_ID';

const initialState = {
  loading: false,
  success: false,
  failure: false,
  roles: {
    applicants: {
      last: false,
      data: null,
    },
    representatives: {
      last: false,
      data: null,
    },
    freelancers: {
      last: false,
      data: null,
    },
    recruiters: {
      last: false,
      data: null,
    },
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case USERS_DATA_REQUEST:
      return {
        loading: true,
        success: false,
        failure: false,
        roles: {
          applicants: {
            last: false,
            data: null,
          },
          representatives: {
            last: false,
            data: null,
          },
          freelancers: {
            last: false,
            data: null,
          },
          recruiters: {
            last: false,
            data: null,
          },
        },
      };
    case USERS_DATA_SUCCESS:
      return {
        loading: false,
        success: true,
        failure: false,
        roles: {
          applicants: {
            last: action.payload.applicants.last,
            data: action.payload.applicants.data,
          },
          representatives: {
            last: action.payload.representatives.last,
            data: action.payload.representatives.data,
          },
          freelancers: {
            last: action.payload.freelancers.last,
            data: action.payload.freelancers.data,
          },
          recruiters: {
            last: action.payload.recruiters.last,
            data: action.payload.recruiters.data,
          },
        },
      };
    case USERS_DATA_FAILURE:
      return {
        loading: false,
        success: false,
        failure: true,
        roles: {
          applicants: {
            last: false,
            data: action.payload,
          },
          representatives: {
            last: false,
            data: action.payload,
          },
          freelancers: {
            last: false,
            data: action.payload,
          },
          recruiters: {
            last: false,
            data: action.payload,
          },
        },
      };
    case USERS_ADDED:
      return {
        ...state,
        roles: {
          ...state.roles,
          [action.payload.key]: {
            last: action.payload.last,
            data: action.payload.data,
            direction: action.payload.direction,
            category: action.payload.category,
          },
        },
      };
    case CHANGE_USER_DATA_BY_ID:
      const newUsersData = [];
      for (let i = 0; i < state.roles[action.payload.key].data.length; i += 1) {
        if (action.payload.id === state.roles[action.payload.key].data[i].uid) {
          newUsersData.push({
            ...state.roles[action.payload.key].data[i],
            ...action.payload.data,
          });
        } else {
          newUsersData.push(state.roles[action.payload.key].data[i]);
        }
      }

      return {
        ...state,
        roles: {
          ...state.roles,
          [action.payload.key]: {
            ...state.roles[action.payload.key],
            data: newUsersData,
          },
        },
      };
    case CHANGE_DATA_BY_ROLE:
      return {
        ...state,
        roles: {
          ...state.roles,
          [action.payload.key]: action.payload.data,
        },
      };
    default:
      return state;
  }
};

export default reducer;

/**
 * Actions
 */

export const usersDataRequest = () => ({
  type: USERS_DATA_REQUEST,
});

export const usersDataSuccess = (payload) => ({
  type: USERS_DATA_SUCCESS,
  payload,
});

export const usersDataFailure = (payload) => ({
  type: USERS_DATA_FAILURE,
  payload,
});

export const usersAdded = (payload) => ({
  type: USERS_ADDED,
  payload,
});

export const changeDataById = (payload) => ({
  type: CHANGE_USER_DATA_BY_ID,
  payload,
});

export const changeDataByRole = (payload) => ({
  type: CHANGE_DATA_BY_ROLE,
  payload,
});
